import { IconButton, styled, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";

export const IconButtonClose = styled(IconButton, {
    label: "SimplePopOver-iconButtonClose",
  })(({ theme }) => ({
    
    "svg":{fontSize: 12,}
  }));

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        text: {
            fontSize: 9,
            marginLeft: theme.spacing(4),
            textAlign: "left",
        },

        root: {
            '.MuiPopover-paper': {
                padding: 0.5,
                pr: 3,
            },
        } as SxProps,
        display: "flex",
        flexDirection: "row",
        justifyContent: "left",
        alignItems: "left",
        position: "relative",
    };
    return classes;
}